import { Checkbox, Flex } from '@enechain/ecloud-designsystem'

type Item<T> = {
  value: T
  label: string
}

type IndeterminateCheckboxGroupProps<T> = {
  items: Array<Item<T>>
  selected: Set<T>
  onToggle: (value: T) => void
  onToggleAll: () => void
  masterLabel: string
}

export const IndeterminateCheckboxGroup = <T,>({
  items,
  selected,
  onToggle,
  onToggleAll,
  masterLabel,
}: IndeterminateCheckboxGroupProps<T>): React.ReactElement => {
  const allChecked =
    items.length > 0 && items.every((i) => selected.has(i.value))
  const someChecked = items.some((i) => selected.has(i.value)) && !allChecked

  return (
    <Flex alignItems="center" flexWrap="wrap" gap={2}>
      <Checkbox
        checked={someChecked ? 'indeterminate' : allChecked}
        onCheckedChange={() => onToggleAll()}
      >
        {masterLabel}
      </Checkbox>
      {items.map((item) => (
        <Checkbox
          key={String(item.value)}
          checked={selected.has(item.value)}
          onCheckedChange={() => onToggle(item.value)}
        >
          {item.label}
        </Checkbox>
      ))}
    </Flex>
  )
}
